"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneInput = void 0;
const intlTelInput = require("intl-tel-input");
const DOM_1 = require("../../../../../public/js/utils/DOM");
const Netwtorking_1 = require("../../../../../public/js/utils/Netwtorking");
const RequestTypes_1 = require("../../../../../public/js/definitions/utils/networking/RequestTypes");
const Sentry_1 = require("../../../../../public/js/utils/Sentry/Sentry");
const ElementValidatorUtil_1 = require("../../../../../public/js/utils/Validator/ElementValidatorUtil");
var PhoneInput;
(function (PhoneInput) {
    class Config {
        static countryDataName = 'country';
        static utilsScriptLocation = "/yarn/intl-tel-input/build/js/utils.js";
        static errorMessageDataName = "error";
        static autofillClassName = 'PhoneInput-input-autoFill';
        static phoneInputElementClassName = 'PhoneInput-input';
        static controlClassName = 'PhoneInput';
        static autofillOptionClassName = "PhoneInput-input-autoFill-container-item";
        static autofillOptionNumberDataName = "number";
        static autofillOptionNumberInternationalDataName = "international";
        static autofillOptionCountryDataName = "country";
        static ipInfoApiEndPoint = "https://ipinfo.io";
    }
    class Control {
        static initialize(container) {
            const elements = DOM_1.DOM.Parser.getHtmlElements(Config.controlClassName, container, true);
            for (let i = 0; i < elements.length; i++) {
                const element = elements[i];
                this.initializeElement(element);
            }
        }
        static initializeElement(element) {
            if (element.parentElement === null) {
                (0, Sentry_1.SentryReportCustomError)('Error loading phone input - parent element missing!');
                return;
            }
            DOM_1.DOM.Parser.getHtmlElementByClass('customDesign-forms-labelContainer', element.parentElement).classList.add('active');
            const inputElement = DOM_1.DOM.Parser.getHtmlElementByQuery('input', element);
            const intl = intlTelInput(inputElement, {
                allowDropdown: true,
                formatOnDisplay: false,
                countryOrder: ["cz", "sk", "us", "gb"],
                initialCountry: DOM_1.DOM.Parser.getDataByNameFromElement(Config.countryDataName, inputElement),
                loadUtilsOnInit: location.origin + Config.utilsScriptLocation,
                geoIpLookup(success) {
                    void Netwtorking_1.Networking.NetworkingController.createRequest({
                        type: RequestTypes_1.RequestTypes.GET, url: Config.ipInfoApiEndPoint, successCallback: (result) => {
                            success(result.country);
                        }, dontProcessPayload: true,
                    });
                },
            });
            setTimeout(() => { inputElement.dispatchEvent(new Event('input')); }, 100);
            setTimeout(() => { inputElement.dispatchEvent(new Event('input')); }, 200);
            setTimeout(() => { inputElement.dispatchEvent(new Event('input')); }, 400);
            setTimeout(() => { inputElement.dispatchEvent(new Event('input')); }, 800);
            this.triggerAutoFill(element, intl);
        }
        static triggerAutoFill(element, intl) {
            const autoFill = element.querySelector('.' + Config.autofillClassName);
            if (autoFill === null) {
                return;
            }
            const input = DOM_1.DOM.Parser.getHtmlElementByQuery('input', element);
            input.addEventListener('focus', () => { autoFill.style.display = 'block'; });
            input.addEventListener('input', () => { this.processAutoFillUpdate(input, autoFill); });
            input.addEventListener('change', () => { this.processAutoFillUpdate(input, autoFill); });
            input.addEventListener('update', () => { this.processAutoFillUpdate(input, autoFill); });
            input.addEventListener('keyup', () => { this.processAutoFillUpdate(input, autoFill); });
            window.addEventListener('click', (evt) => {
                if (autoFill.style.display === 'none') {
                    return;
                }
                const clickedInside = DOM_1.DOM.Parser.parentContainsTheClass(Config.phoneInputElementClassName, evt.target);
                if (clickedInside) {
                    return;
                }
                autoFill.style.display = 'none';
            });
            const optionTriggers = DOM_1.DOM.Parser.getHtmlElements(Config.autofillOptionClassName, autoFill, true);
            for (let i = 0; i < optionTriggers.length; i++) {
                const optionTrigger = optionTriggers[i];
                const optionNumber = DOM_1.DOM.Parser.getDataByNameFromElement(Config.autofillOptionNumberDataName, optionTrigger);
                const optionCountry = DOM_1.DOM.Parser.getDataByNameFromElement(Config.autofillOptionCountryDataName, optionTrigger);
                optionTrigger.addEventListener('click', (event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    intl.setCountry(optionCountry);
                    intl.setNumber(optionNumber);
                    autoFill.style.display = 'none';
                    input.dispatchEvent(new Event('input'));
                });
            }
        }
        static processAutoFillUpdate(input, autoFill) {
            const inputValue = input.value.toString().replace(/\D/g, '').trim();
            const inputValueNumbers = input.value.toString().replace(/\D/g, '').split('');
            const emptyInputValue = inputValue.length === 0;
            const options = DOM_1.DOM.Parser.getHtmlElements(Config.autofillOptionClassName, autoFill, true);
            let regex = null;
            if (inputValueNumbers.length !== 0) {
                regex = '.*(';
                for (const inputNumber of inputValueNumbers) {
                    regex += inputNumber + '[\\(\\)\\s]*';
                }
                regex += ')';
            }
            let shown = 0;
            for (let i = 0; i < options.length; i++) {
                const option = options[i];
                const optionNumber = DOM_1.DOM.Parser.getDataByNameFromElement(Config.autofillOptionNumberInternationalDataName, option).replace(/\D/g, '');
                const optionText = option.textContent?.toString().trim();
                const optionMatch = optionNumber.includes(inputValue);
                const regexCompiled = regex ? new RegExp(regex, 'gs') : null;
                if (shown >= 5) {
                    option.style.display = 'none';
                    continue;
                }
                if (emptyInputValue) {
                    option.style.display = 'block';
                    shown++;
                }
                else if (optionMatch) {
                    option.style.display = 'block';
                    shown++;
                    if (regexCompiled) {
                        const find = regexCompiled.exec(optionText);
                        if (find && find[1]) {
                            option.innerHTML = optionText.replace(find[1], '<b>' + find[1] + '</b>');
                        }
                    }
                }
                else {
                    option.style.display = 'none';
                }
            }
        }
    }
    PhoneInput.Control = Control;
    class Helpers {
        static validatePhoneInput(input) {
            const iti = intlTelInput.getInstance(input);
            if (!iti) {
                return;
            }
            const problemString = DOM_1.DOM.Parser.getDataByNameFromElement(Config.errorMessageDataName, input);
            if (input.value.trim().length > 0 && (!iti.isValidNumber() || /[^0-9+\-()\s]/.test(input.value.trim()))) {
                input.dataset.valid = "false";
                ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(input, problemString, false);
                return;
            }
            else {
                const dialCode = iti.getSelectedCountryData().dialCode;
                if (!dialCode) {
                    if (input.value.trim().length > 0) {
                        (0, Sentry_1.SentryReportCustomError)('PhoneInput: Impossible to find dial code', { inputValue: input.value.trim() });
                    }
                    return;
                }
                const numberNational = iti.getNumber(2).replace(/\D/g, '').trim();
                const numberInternational = iti.getNumber(1).replace(/[^0-9+]/g, '').trim();
                input.dataset.data = JSON.stringify({
                    dialCode: parseInt(dialCode),
                    countryCode: iti.getSelectedCountryData().iso2,
                    numberNational: numberNational.length > 0 ? numberNational : null,
                    numberInternational: numberInternational.length > 0 ? numberInternational : null,
                });
            }
            ElementValidatorUtil_1.ElementValidatorUtil.updateHelpElement(input, problemString, true);
        }
    }
    PhoneInput.Helpers = Helpers;
})(PhoneInput || (exports.PhoneInput = PhoneInput = {}));
